import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Search, Loader } from 'react-feather';
import "../../css/global.css"
import { useHistory } from 'react-router-dom';
import BidDetailModal from './BidDetailModal'; // ✅ 추가

const SearchBar = () => {
    const [keyword, setKeyword] = useState('');
    const [searchType, setSearchType] = useState('기업 검색');
    const [suggestions, setSuggestions] = useState([]);
    const [selectedItem, setSelectedItem] = useState(null);
    const [loading, setLoading] = useState(false);
    const [modalOpen, setModalOpen] = useState(false); // ✅ 추가
    const [selectedBidNumber, setSelectedBidNumber] = useState(null); // ✅ 추가
    const history = useHistory();

    useEffect(() => {
        const fetchSuggestions = async () => {
            if (keyword.length < 2 || selectedItem) {
                setSuggestions([]);
                return;
            }

            let url = '';
            if (searchType === '기업 검색') {
                url = `${process.env.REACT_APP_API_BASE_URL}/companies/autocomplete?keyword=${keyword}`;
            } else if (searchType === '과업 검색 (공고명)') {
                url = `${process.env.REACT_APP_API_BASE_URL}/bids/autocomplete/title?keyword=${keyword}`;
            } else if (searchType === '과업 검색 (입찰공고번호)') {
                url = `${process.env.REACT_APP_API_BASE_URL}/bids/autocomplete/notice-number?keyword=${keyword}`;
            }

            try {
                const res = await axios.get(url);
                setSuggestions(res.data);
            } catch (err) {
                console.error('자동완성 오류:', err);
                setSuggestions([]);
            }
        };

        fetchSuggestions();
    }, [keyword, searchType, selectedItem]);

    const handleSearch = () => {
        if (!keyword.trim()) return;
        setLoading(true);

        let matched = selectedItem;

        if (!matched) {
            matched = suggestions.find(item =>
                item.name === keyword.trim() ||
                item.title === keyword.trim() ||
                item.bidNoticeNumber === keyword.trim()
            );
        }

        if (matched) {
            if (searchType === '기업 검색') {
                const id = matched.bizNumber;
                const path = `/search/companies/?bizNumber=${encodeURIComponent(id)}`;
                history.push(path);
            } else {
                const bidKey = matched.bidNoticeNumber || matched.title;
                setSelectedBidNumber(bidKey); // ✅ 모달용 bid 번호 설정
                setModalOpen(true);           // ✅ 모달 열기
            }
        } else {
            alert("목록에서 선택된 값이 아닙니다.");
        }

        setSuggestions([]);
        setSelectedItem(null);
        setLoading(false);
        setKeyword('');
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            handleSearch();
        }
    };

    const handleSelectSuggestion = (item) => {
        const label = item.name || item.title || item.bidNoticeNumber;
        setKeyword(label);
        setSelectedItem(item);
        setSuggestions([]);
    };

    const handleChange = (e) => {
        setKeyword(e.target.value);
        setSelectedItem(null);
    };

    return (
        <div className="relative w-full">
            <div className="flex w-full rounded-lg border border-gray-300 shadow overflow-hidden">
                <select
                    value={searchType}
                    onChange={(e) => {
                        setSearchType(e.target.value);
                        setKeyword('');
                        setSelectedItem(null);
                    }}
                    className="bg-gray-50 text-sm px-3 py-2 border-r border-gray-300 outline-none"
                >
                    <option>기업 검색</option>
                    <option>과업 검색 (공고명)</option>
                    <option>과업 검색 (입찰공고번호)</option>
                </select>

                <input
                    type="text"
                    className="flex-grow px-3 py-2 focus:outline-none"
                    placeholder="검색어를 입력하세요"
                    value={keyword}
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                />

                <button
                    type="button"
                    onClick={handleSearch}
                    className="px-4 bg-light-blue-500 text-white hover:bg-blue-600 flex items-center justify-center"
                    disabled={loading}
                >
                    {loading ? <Loader className="animate-spin" size={18} /> : <Search size={18} />}
                </button>
            </div>

            {/* 자동완성 목록 */}
            {suggestions.length > 0 && (
                <ul className="absolute left-0 right-0 bg-white shadow rounded mt-1 max-h-48 overflow-auto z-10 border border-gray-200">
                    {suggestions.map((item, index) => (
                        <li
                            key={index}
                            className="p-3 hover:bg-gray-100 cursor-pointer"
                            onClick={() => handleSelectSuggestion(item)}
                        >
                            {item.name
                                ? `${item.name} (${item.bizNumber})`
                                : `${item.title} (${item.bidNoticeNumber})`}
                        </li>
                    ))}
                </ul>
            )}

            {/* ✅ 모달 표시 */}
            {modalOpen && selectedBidNumber && (
                <BidDetailModal
                    isOpen={modalOpen}
                    bidNumber={selectedBidNumber}
                    bidNoticeOrder="000"
                    onClose={() => setModalOpen(false)}
                />
            )}

            {/* 선택된 항목 디버그용 시각화 */}
            {selectedItem && (
                <div className="text-sm text-gray-500 mt-2">
                    선택된 항목:{" "}
                    {selectedItem.name
                        ? `${selectedItem.name} (${selectedItem.bizNumber})`
                        : `${selectedItem.title} (${selectedItem.bidNoticeNumber})`}
                </div>
            )}
        </div>
    );
};

export default SearchBar;